import { getCreateData, getStates, getTemplates, getTodoDetails } from '../api'
import axios from 'axios'
import store from '@/store'

function setDataForKanbanBoardPage(rootState, commit, context) {
  const states = rootState['kanban-board'].states
  return axios.all([getCreateData(context), getTemplates()]).then(
    axios.spread(({ data: { result: createData } }, { data: { result: templates } }) => {
      createData.states = states
      commit('setCreateData', createData)
      commit('setTemplates', templates)
    })
  )
}

function setDataForTodoTemplatesPage(commit, context) {
  return axios.all([getCreateData(context), getStates()]).then(
    axios.spread(({ data: { result: createData } }, { data: { result: states } }) => {
      createData.states = states
      commit('setCreateData', createData)
    })
  )
}

function setDataForRemainingPages(commit, context) {
  return axios.all([getCreateData(context), getStates(), getTemplates()]).then(
    axios.spread(({ data: { result: createData } }, { data: { result: states } }, { data: { result: templates } }) => {
      createData.states = states
      commit('setCreateData', createData)
      commit('setTemplates', templates)
    })
  )
}

const initialState = () => ({
  createData: null,
  templates: null,
  selectedTemplate: null,
  entity: null // we need it when we open the TodoModal from sub show -> notes & tasks page
})

export default {
  namespaced: true,
  state: initialState(),

  getters: {
    templateOptions(state) {
      if (!state.templates) return null
      return state.templates.map(t => ({ label: t.title, value: t.id }))
    }
  },

  mutations: {
    setCreateData: (state, payload) => (state.createData = payload),
    setEntityForTodo: (state, payload) => (state.entity = payload),
    setTemplates: (state, payload) => (state.templates = payload),
    addTemplate: (state, payload) => state.templates.push(payload),
    setSelectedTemplate: (state, payload) => (state.selectedTemplate = payload),
    resetCreateData: state => {
      state.createData = null
      state.entity = null
      state.templates = null
      state.selectedTemplate = null
    },
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetCreateData({ commit, rootState }, context) {
      if (store.state.hasOwnProperty('kanban-board')) return setDataForKanbanBoardPage(rootState, commit, context)
      if (context === 'templates') return setDataForTodoTemplatesPage(commit, 'kanban')
      return setDataForRemainingPages(commit, context) // Remaining pages: subscription show, publisher show, dashboard, etc
    },

    getAndSetSelectedTemplate({ commit }, templateId) {
      return getTodoDetails(templateId).then(({ data: { result: template } }) =>
        commit('setSelectedTemplate', template)
      )
    }
  }
}
